function Credentials(data){
    let credentials = data || {};
    this.phoneNumber = credentials.phoneNumber;
    this.email = credentials.email;
    this.password = credentials.password;
}
module.exports = Credentials;